import * as echarts from "echarts";

/**
 * 图表自适应 mixin：监听窗口尺寸变化，调用 echarts 实例的 resize。
 * 要求组件有 id prop，且图表通过 echarts.init(document.getElementById(this.id)) 创建。
 */
export default {
    mounted() {
        this._chartResizeHandler = () => {
            const dom = document.getElementById(this.id);
            const inst = dom && echarts.getInstanceByDom(dom);
            if (inst) inst.resize();
        };
        window.addEventListener('resize', this._chartResizeHandler);
        // 兜底：弹窗等容器内的图表挂载时可能尚未完成布局，延迟重绘一次
        this._chartResizeTimer = setTimeout(this._chartResizeHandler, 300);
    },
    unmounted() {
        window.removeEventListener('resize', this._chartResizeHandler);
        clearTimeout(this._chartResizeTimer);
    }
};
